import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSelector, shallowEqual } from 'react-redux';
import { OneColumnExpanded } from '@/pages/Home';
import Footer from '@/components/Footer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {
  HeaderContainer,
  MainContainer,
  NavContainer,
} from '@/components/OurPlans/styled';
import { Row, Column } from '@simplywallst/ui-core';
import { OneColumn } from '@/components/Layout';
import DocumentHeader from '@/components/DocumentHeader';
import { Navigation } from '@/components/Navigation';
import Pagination from '@/components/Pagination';

import Podcast from './components/Podcast';
import Sidebar from './components/Sidebar';
import { getPodcasts, getDefaultPodcasts } from './query';
import { Header, PodcastListContainer, InnerContainer } from './styled';
import { ROUTE_PODCASTS } from '@/constants/routes';

const Podcasts = () => {
  const page = useSelector<{ location: { query?: { page?: string } } }, number>(
    (state) => {
      const pageQuery = state.location.query?.page;
      if (
        typeof pageQuery === 'undefined' ||
        pageQuery.match(/^[0-9]+$/) === null ||
        isNaN(Number(pageQuery))
      ) {
        return 1;
      }
      return Number(pageQuery);
    },
    shallowEqual
  );

  const { data: { totalPages, podcasts } = getDefaultPodcasts() } = useQuery({
    queryKey: ['podcasts-page', page],
    queryFn: getPodcasts,
    staleTime: Infinity,
  });

  const actionLink = useCallback((page: number) => {
    return {
      type: ROUTE_PODCASTS,
      payload: {
        query: {
          page: page + '',
        },
      },
    };
  }, []);

  return (
    <>
      <MainContainer>
        <HeaderContainer justifyContent="center">
          <OneColumn>
            <DocumentHeader allowCrawlers title="Podcasts" />
            <NavContainer>
              <Navigation />
            </NavContainer>
            <Header>
              <h1>Podcasts</h1>
            </Header>
          </OneColumn>
        </HeaderContainer>
        <Row justifyContent="center">
          <InnerContainer>
            <Row>
              <Column colMd={8} col={12}>
                <PodcastListContainer>
                  {podcasts.map((podcast) => (
                    <Podcast
                      key={podcast.title}
                      title={podcast.title}
                      description={documentToReactComponents(
                        podcast.description
                      )}
                      podcastUrl={podcast.podcastUrl}
                    />
                  ))}
                </PodcastListContainer>
                {totalPages > 1 && (
                  <Pagination
                    styleType="light"
                    totalPages={totalPages}
                    currentPage={page}
                    actionLink={actionLink}
                  />
                )}
              </Column>
              <Column colMd={4} col={12}>
                <Sidebar />
              </Column>
            </Row>
          </InnerContainer>
        </Row>
      </MainContainer>
      <OneColumnExpanded>
        <Footer />
      </OneColumnExpanded>
    </>
  );
};

export default Podcasts;
